import React, { useEffect, useState } from "react";
import { SwiperSlide, Swiper } from "swiper/react";
import { ActionButtons } from "../ActionButtons/ActionButtons";
import { Navigation, Pagination } from "swiper";
import styles from "./Slider.module.scss";
import "swiper/scss";
import "swiper/css/pagination";
import "swiper/css/navigation";

export const Slider = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiper, setSwiper] = useState<any>(null);

  useEffect(() => {}, [swiper]);
  return (
    <Swiper
      pagination={{ type: "progressbar" }}
      modules={[Navigation, Pagination]}
      onSlideChange={(e) => {
        setActiveIndex(e.activeIndex);
      }}
      onSwiper={(e) => setSwiper(e)}
      className={styles.Slider}
      loop={true}
    >
      {children.map((child, index) => {
        return (
          <SwiperSlide key={index}>
            {child}
            {swiper && (
              <ActionButtons
                activeIndex={activeIndex}
                swiper={swiper}
              ></ActionButtons>
            )}
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
